import Vue from 'vue'
import merge from 'lodash.merge'
const mutations = {
  updateBrandingColour (state, payload) {
    state.brandingColour = payload
  },
  setBrowserUsed (state, payload) {
    state.browserUsed = payload
  },
  updateToken (state, token) {
    state.token = token
  },
  sectionLoaded (state, sectionName) {
    state.sectionsOrderList.forEach((section) => {
      if (section.name === sectionName) {
        section.loaded = true
      }
    })
  },
  addPage (state, pageObj) {
    state.pages.push(pageObj)
  },
  resetPages (state) {
    state.pages = []
  },
  addToTotalPageCount (state, pages) {
    state.totalPages.count += pages
  },
  addToTotalPagesLoaded (state, pages) {
    state.totalPages.loaded += pages
  },
  createTimestamp (state, timestamp) {
    state.timestamp = timestamp
  },
  setReportPreferences (state, payload) {
    state.reportPreferences = payload
  },
  setDataReport (state, payload) {
    state.dataReport = payload
  },
  createReportSections (state, payload) {
    const sections = {}
    state.sectionsOrderList = []
    payload.forEach(section => {
      if (section.type !== 'white-label') {
        sections[section.type] = section
        state.sectionsOrderList.push({ name: `report-${section.type}`, loaded: false })
      } else {
        state.whiteLabel = true
      }
    })
    state.reportSections = sections
  },
  mergePreferenceProperty (state) {
    if (state.reportSections.property) {
      const img = state.reportSections.property.data.image
      const data = merge(state.reportSections.property.data, state.reportPreferences.property)
      Object.keys(data).forEach((prop) => {
        Vue.set(state.reportSections.property.data, prop, data[prop])
      })
      Vue.set(state.reportSections.property.data, 'image', img)
    }
  },
  remapUnknowns (state) {
    if (state.reportSections.neighbours) {
      state.reportSections.neighbours.data.charts.tenure['Not profiled'] = state.reportSections.neighbours.data.charts.tenure.Unknown
      delete state.reportSections.neighbours.data.charts.tenure.Unknown
      state.reportSections.neighbours.data.charts.gender['Not profiled'] = state.reportSections.neighbours.data.charts.gender.Unknown
      delete state.reportSections.neighbours.data.charts.gender.Unknown
      state.reportSections.neighbours.data.charts.mortgage['Not profiled'] = state.reportSections.neighbours.data.charts.mortgage.Unknown
      delete state.reportSections.neighbours.data.charts.mortgage.Unknown
    }
  },
  updateSections (state, payload) {
    state.sectionsOffsetTop = payload
  },
  updateReportExpiredContact (state, payload) {
    state.expiredReportContact = payload
  },
  clearSectionList (state) {
    state.sectionsOrderList = []
  },
  neightbourhoodBackwardCompatibility (state) {
    if (!state.reportSections.neighbours.data.hasOwnProperty('show')) {
      state.reportSections.neighbours.data.show = { age_makeup: 1, text_custom: 0, tenure_graph: 1, text_default: 1, gender_makeup: 1, mortage_graph: 1, years_living_graph: 1 }
    }
  },
  yourpropertyBackwardCompatibility (state) {
    if (!state.reportSections.property.data.hasOwnProperty('show')) {
      state.reportSections.property.data.show = { time_graph: 1, text_custom: 0, text_default: 1, property_details: 1 }
    }
  },
  analysisBackwardCompatibility (state) {
    if (!state.reportSections.analysis.data.hasOwnProperty('show')) {
      state.reportSections.analysis.data.show = { text_custom: 0, text_default: 1, sales_by_price: 1, area_performance: 1, peak_completion_month: 1, peak_instructions_month: 1 }
    }
  },
}

export default mutations
